/**
 * @deprecated Use OPL Table
 * thanks <3
 */

import styled, { StyledComponent, DefaultTheme, AnyStyledComponent } from 'styled-components';
import Header from './components/Header';
import Body from './components/Body';
import Row from './components/Row';
import Cell, { CenterAlignedCell, RightAlignedCell } from './components/Cell';

interface TableDTO {
  Body: AnyStyledComponent;
  Cell: AnyStyledComponent;
  CenterAlignedCell: AnyStyledComponent;
  Header: AnyStyledComponent;
  RightAlignedCell: AnyStyledComponent;
  Row: AnyStyledComponent;
}

type TableStyledDTO = TableDTO & StyledComponent<'table', DefaultTheme, {}, never>;

const Table = styled.table`
  border-spacing: 0;
  border: 1px solid #d9d7d7;
  border-radius: 4px;
  background: #fff;
  color: #4a4a4a;
` as TableStyledDTO;

Table.Body = Body;
Table.Cell = Cell;
Table.CenterAlignedCell = CenterAlignedCell;
Table.Header = Header;
Table.RightAlignedCell = RightAlignedCell;
Table.Row = Row;

/** @component */
export default Table;
